import type {AppIconProps} from "../Icons.types";
import {getClassNames} from "../Icons.utils";
import styles from "./PlusAlternative.module.scss";

export const AppPlusAlternativeIcon = (props: AppIconProps) => {
  const {className, ...rest} = props;
  const classNames = getClassNames(styles.icon, className);

  return (
    <svg {...rest} className={classNames} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect rx="4" fill="#0B60D4"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M16 10C15.4477 10 15 10.4477 15 11V15H11C10.4477 15 10 15.4477 10 16C10 16.5523 10.4477 17 11 17H15V21C15 21.5523 15.4477 22 16 22C16.5523 22 17 21.5523 17 21V17H21C21.5523 17 22 16.5523 22 16C22 15.4477 21.5523 15 21 15H17V11C17 10.4477 16.5523 10 16 10Z" fill="white"/>
    </svg>
  );
};